import script from "./CalendarioActividades.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioActividades.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioActividades.vue?vue&type=style&index=0&id=2465207c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2465207c"]])

export default __exports__